import axiosClient from "./axiosClient";

export const getRepositoryDetails = () => {
    return axiosClient.get("/api/repo/details");
};
export const getRepoGraphURL = (repoId, fileId = null) => {
    const params = {};
    if (fileId) {
        params.fileIds = fileId;
    }
    return axiosClient.get(`/api/lineage/graph/url/${repoId}`, { params });
};

export const advLineageChat = (body) => {
  return axiosClient.post("/api/lineage/graph/answer", body);
};
